module.exports = __webpack_public_path__ + "static/img/HuangMu_jianjiePic.cb7717ad.png";